import { useContext, useState } from "react";
import LoadingIcon from "../../assets/LoadingIcon";
import { isEmpty } from "../../helpers/validator";
import SuperAdminAuthContext from "../../context/superadmin/SuperAdminAuthContext";
import { loginSuperAdmin } from "../../services/superadmin-tenants";

const SuperAdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const { saveSuperAdmin } = useContext(SuperAdminAuthContext);

  const handleSubmit = async () => {
    const nextErrors = [];
    if (isEmpty(email)) {
      nextErrors.push("Please enter the email.");
    }
    if (isEmpty(password)) {
      nextErrors.push("Please enter the password.");
    }

    if (nextErrors.length > 0) {
      setErrors(nextErrors);
      return;
    }

    setLoading(true);
    setErrors([]);
    try {
      const response = await loginSuperAdmin({ email, password });
      if (!response?.token) {
        throw new Error("Token is missing from login response.");
      }
      saveSuperAdmin(response.token, response.user ?? null);
    } catch (e) {
      setErrors([e.message]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-full h-full py-40 min-h-screen bg-slate-200">
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-neutral-light border-0">
              <div className="flex-auto px-4 lg:px-10 py-10">
                <div className="text-slate-400 text-center mt-3 mb-6 font-bold">
                  <span className="uppercase text-xl text-gray-900">
                    Super Admin Login
                  </span>
                </div>
                {errors.length > 0 ? (
                  <div className="bg-errorBg text-errorText text-sm p-4 mb-8 border-errorBorder border-[0.5px] rounded-sm">
                    <ul>
                      {errors.map((error, index) => (
                        <li key={index}>{error}</li>
                      ))}
                    </ul>
                  </div>
                ) : null}
                <form>
                  <div className="relative w-full mb-3">
                    <label className="block uppercase text-slate-600 text-xs font-bold mb-2">
                      Email
                    </label>
                    <input
                      type="email"
                      className="border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="relative w-full my-6">
                    <label className="block uppercase text-slate-600 text-xs font-bold mb-2">
                      Password
                    </label>
                    <input
                      type="password"
                      className="border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="text-center mt-8">
                    <button
                      className="flex gap-1 justify-center items-center bg-primary-light text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg disabled:bg-gray-400 mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? <LoadingIcon /> : null}
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
